import React from 'react';

interface WarningIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const WarningIcon: React.FC<WarningIconProps> = ({ className = '', width = 16, height = 17 }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 17'
      fill='none'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.31532 2.66861C7.06393 1.37231 8.93578 1.37231 9.68374 2.66861L14.4509 10.9312C15.1988 12.2275 14.2629 13.8479 12.7663 13.8479H3.23272C1.73615 13.8479 0.800872 12.2275 1.54884 10.9312L6.31467 2.66861H6.31532ZM7.99985 6.06944C8.12878 6.06944 8.25242 6.12066 8.34359 6.21182C8.43475 6.30299 8.48596 6.42663 8.48596 6.55555V8.98611C8.48596 9.11503 8.43475 9.23868 8.34359 9.32984C8.25242 9.42101 8.12878 9.47222 7.99985 9.47222C7.87093 9.47222 7.74728 9.42101 7.65612 9.32984C7.56496 9.23868 7.51374 9.11503 7.51374 8.98611V6.55555C7.51374 6.42663 7.56496 6.30299 7.65612 6.21182C7.74728 6.12066 7.87093 6.06944 7.99985 6.06944ZM7.99985 11.4167C8.12878 11.4167 8.25242 11.3655 8.34359 11.2743C8.43475 11.1831 8.48596 11.0595 8.48596 10.9306C8.48596 10.8016 8.43475 10.678 8.34359 10.5868C8.25242 10.4957 8.12878 10.4444 7.99985 10.4444C7.87093 10.4444 7.74728 10.4957 7.65612 10.5868C7.56496 10.678 7.51374 10.8016 7.51374 10.9306C7.51374 11.0595 7.56496 11.1831 7.65612 11.2743C7.74728 11.3655 7.87093 11.4167 7.99985 11.4167Z'
        fill='#D04D4D'
      />
    </svg>
  );
};

export default WarningIcon;
